//------- import Libraries
import pokemon from "pokemontcgsdk";
import { Formik, Form } from "formik";
import { connect } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { Col, Row } from "react-bootstrap";
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

//------- import Custom Reuseable Components
import {
  Set,
  Topbar,
  Button,
  Rarity,
  Barcode,
  SelectGrade,
  CheckboxField,
  CustomTooltip,
  ProductTagList,
  SelectLanguage,
  InputTextField,
  InputNumberField,
  SelectCardRarity,
  CategoriesDropdown,
  ToggleButtonWithText,
  NetworkAveragePriceSelect,
} from "../../../../shared/components";

import {
  CustomItemCategorySelectField,
  CustomItemConditionSelectField,
  CustomItemProductTypeSelectField,
  CustomItemSubcategorySelectField,
} from "../../Shared";

import ItemHistoryModal from "./ItemHistoryModal/ItemHistoryModal";
import PrintLabelModal from "../printingLabelModal/PrintLabelModal";
import ProductImage from "../../../../assets/images/productimage.png";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import PricechartingImage from "../../../../assets/images/PricechartingImage.png";
import TransferInventoryModal from "../TransferInventoryModal/TransferInventoryModal";
import ShopifyPresetsMappingModal from "../../../Settings/ShopifyPresets/AddNewPreset/ShopifyPresetsMappingModal";

//------ import validation schemas
import { editInventoryValidationSchema } from "../../../../shared/validationSchema/validationSchema";

//------ import actions
import {
  systemActions,
  shopifyActions,
  inventoryActions,
} from "../../../../redux/actions";

//------ import System Enums
import { PRODUCT_TYPES_ENUMS } from "../../../../system/globalEnums";

//------- import Icons

import {
  DollarIcon,
  PercentageIcon,
  LogoImageReplaceIcon,
  PricechartingIcon,
} from "../../../../assets/icons/iconsProvider";

//------- import Constants
import {
  toastType,
  EMPTY_STRING,
  toastMessages,
  globalConstants,
  shopifyConstants,
  defaultGridState,
  inventoryConstants,
  buttonNameConstants,
  buttonTypeConstants,
  routesPathConstants,
  categoryDropdownConstants,
  NETWORK_AVERAGE_PRICE_TYPES,
  toggleSwitchButtonConstants,
  INITIAL_VALUE_TYPES,
} from "../../../../constants";

//------ import Utility Functions
import {
  customToast,
  stringToSlug,
  convertToUsd,
  getShortestSku,
  isTcgPlayerApi,
  isSystemProduct,
  getDefaultFields,
  isSpinnerEnabled,
  isMarketPriceHigh,
  handleIsCustomItem,
  isShopifyConnected,
  onSelectTagsChange,
  handleViewTCGPlayer,
  handleViewEbaySales,
  parseToDecimalNumber,
  isSerialNumberUnique,
  isProductMetaDataSame,
  handleIsLinkToShopify,
  getProductSubCategory,
  handleConditionChange,
  getMappedShopifyFields,
  createCompanyDynamicUrl,
  getTypeOrCategoryObject,
  convertToFixedPrecision,
  handleUploadProductImage,
  calculateProfitAndMargin,
  handleBeautifyMarketPrice,
  getTypeOrCategoryIdByName,
  isTransferInventoryEnabled,
  handleShowNintendoCondition,
  handleProductConditionUpdate,
  getAddInventoryPricePayloadObject,
  getAddInventoryPartialInitialValues,
  parseToThousandSeperatorDecimalNumber,
  getAddInventoryRootPayloadPartialObject,
  prepareFilterForInventoryHistoryPaginationCall,
  handleAverageOutUnitPurcasePrice,
} from "../../../../shared/utility";

pokemon.configure({ apiKey: process.env.REACT_APP_POKEMON_API_KEY });

const EditInventory = (props) => {
  //------- destucture props
  const {
    shopify,
    stores,
    currentStoreCompany,
    inventory,
    productTags,
    customTypes,
    currentStore,
    spinnerArray,
    tradeDiscount,
    updateInventory,
    quantityShrink,
    activateSpinner,
    customCategories,
    inventoryProducts,
    deactivateSpinner,
    customSubCategories,
    getShopifyMappingsById,
    getTcgPlayerProductById,
    priceChartingProductInfo,
    setProductShopifySettings,
    createProductMappingObject,
    setPokemonProductInReducer,
    getPricechartingProductById,
    setPriceChartingProductInfo,
    emptyShopifyProductSettings,
    getPaginatedInventoryHistory,
    getInventoryByPricechartingId,
    getInventoryByCustomItemCheck,
    emptyPriceChartingProductObject,
  } = props;

  //-------preset prices
  const { inventoryHistory, productShopifySettings } = inventory;

  const { state } = useLocation();
  const navigate = useNavigate();

  //-------is shopify store connected?
  const isShopifyStoreConnected = isShopifyConnected(currentStore);

  //------- usestates
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [showIframe, setShowIframe] = useState(false);
  const handleCloseIfram = () => setShowIframe(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [conditionList, setConditionList] = useState([]);
  const [productTagsList, setProductTagsList] = useState([]);
  const [productUrl, setProductUrl] = useState(EMPTY_STRING);
  const [initialMapping, setInitialMapping] = useState(false);
  const [productCondition, setProductCondition] = useState({});
  const [shrinkValue, setShrinkValue] = useState(EMPTY_STRING);
  const [printLabelModal, setPrintLabelModal] = useState(false);
  const [isItemHistoryModal, setIsItemHistoryModal] = useState(false);
  const [updatedInventory, setUpdatedInventory] = useState(EMPTY_STRING);
  const [isShopifyPresetModal, setIsShopifyPresetModal] = useState(false);
  const [isConsolidationModal, setIsConsolidationModal] = useState(false);
  const [productDataObject, setProductDataObject] = useState({
    imgUrl: state?.data?.imgUrl,
  });
  const [isTransferInventoryModal, setIsTransferInventoryModal] =
    useState(false);
  const [productType, setProductType] = useState(PRODUCT_TYPES_ENUMS.ALL);
  const [gridState, setGridState] = useState({
    ...defaultGridState,
    pageSize: inventoryConstants.ITEM_HISTORY_LIST_LENGTH,
  });
  const [timeFrame, setTimeFrame] = useState({
    start: "",
    end: "",
    duration: "all",
  });
  const [transactionType, setTransactionType] = useState({
    label: globalConstants.ALL,
    value: globalConstants.ALL,
  });

  //------- handle show iframe
  const handleShowIfram = () => setShowIframe(true);

  //------useRef
  const formRef = useRef(null);
  const hiddenFileInput = useRef(null);
  const isFirstRenderRef = useRef(true);

  //------- initial Constants
  const isCustomItem = handleIsCustomItem(state?.data);

  //------- form initial values
  const initialValues = {
    productName: state?.data?.product_name,
    condition: state?.data?.price?.type,
    productType: getTypeOrCategoryIdByName(
      customTypes,
      state?.data?.productType
    ),
    category_name: getTypeOrCategoryIdByName(
      customCategories,
      state?.data?.category_name,
      state?.data?.productType
    ),
    subcategory: getTypeOrCategoryIdByName(
      customSubCategories,
      state?.data?.subcategory,
      state?.data?.productType,
      state?.data?.category_name
    ),
    unitsellprice:
      state?.data?.price?.unit_sell_price !== null &&
      state?.data?.price?.unit_sell_price !== undefined
        ? parseToDecimalNumber(state.data.price.unit_sell_price)
        : EMPTY_STRING,
    costPerItem:
      state?.data?.price?.unit_purchase_price !== null &&
      state?.data?.price?.unit_purchase_price !== undefined
        ? convertToFixedPrecision(state.data.price.unit_purchase_price)
        : EMPTY_STRING,
    onlineCostPerItem:
      state?.data?.price?.onlineUnitPurchasePrice !== null &&
      state?.data?.price?.onlineUnitPurchasePrice !== undefined
        ? convertToFixedPrecision(state.data.price.onlineUnitPurchasePrice)
        : EMPTY_STRING,
    profit:
      state?.data?.price?.unit_sell_price !== null &&
      state?.data?.price?.unit_sell_price !== undefined
        ? convertToFixedPrecision(
            state?.data?.price?.unit_sell_price -
              state?.data?.price?.unit_purchase_price
          )
        : 0,
    onlineProfit:
      state?.data?.price?.onlinePrice !== null &&
      state?.data?.price?.onlinePrice !== undefined
        ? convertToFixedPrecision(
            state?.data?.price?.onlinePrice -
              state?.data?.price?.onlineUnitPurchasePrice
          )
        : 0,
    onlineMargin:
      state?.data?.price?.onlinePrice !== null &&
      state?.data?.price?.onlinePrice !== undefined
        ? convertToFixedPrecision(
            ((state?.data?.price?.onlinePrice -
              state?.data?.price?.onlinePrice) /
              state?.data?.price?.onlinePrice) *
              100
          )
        : 0,
    margin:
      state?.data?.price?.unit_sell_price !== null &&
      state?.data?.price?.unit_sell_price !== undefined
        ? convertToFixedPrecision(
            ((state?.data?.price?.unit_sell_price -
              state?.data?.price?.unit_purchase_price) /
              state?.data?.price?.unit_sell_price) *
              100
          )
        : 0,
    unitsOnHand:
      (state?.data?.trackQuantity && state?.data?.price?.quantity != null) ||
      state?.data?.trackQuantity === undefined ||
      state?.data?.trackQuantity === null
        ? state.data.price.quantity
        : EMPTY_STRING,
    originalPrice: state?.data?.price?.unit_sell_price || 0,
    originalCondition: state?.data?.price?.type || EMPTY_STRING,
    upc: state?.data?.upc || EMPTY_STRING,
    trackQuantity:
      state?.data?.trackQuantity === undefined ||
      state?.data?.trackQuantity === null
        ? true
        : state?.data?.trackQuantity,
    isInstoreStockPrice: false,
    ...getAddInventoryPartialInitialValues(
      {
        ...state?.data,
        ...state?.data?.price,
      },
      INITIAL_VALUE_TYPES.EDIT_INVENTORY
    ),
  };

  //-------Toggle Print Label Modal
  const togglePrintLabelModal = () => {
    setPrintLabelModal(!printLabelModal);
  };
  const handleCancelButton = () => {
    navigate(createCompanyDynamicUrl(routesPathConstants.INVENTORY), {
      state: {
        gridState: state?.gridState,
        scrollRef: state?.scrollRef,
      },
    });
  };

  //------- toggle shopify mapping modal
  const toggleShopifyMappingModal = () => {
    if (isShopifyPresetModal) {
      setInitialMapping(false);
    }
    setIsShopifyPresetModal((prev) => !prev);
  };

  //-------handle save mapping
  const handleSaveMappning = (updatedFields) => {
    let dataToUpdate = {
      ...productShopifySettings?.marginObject,
      shopifyMapping: getMappedShopifyFields(updatedFields),
    };
    createProductMappingObject(
      currentStore?.id,
      dataToUpdate,
      toggleShopifyMappingModal
    );
  };

  const handleShrinkModalSubmit = (isAddQuantityInShrink) => {
    setShow(false);
    updateInventory(
      currentStore?.id,
      updatedInventory,
      true,
      state?.gridState,
      navigate,
      state?.scrollRef,
      isAddQuantityInShrink
    );
    if (isAddQuantityInShrink) {
      const shrinkInventoryObject = {
        ...state.data,
        shrinkQuantity: shrinkValue,
      };
      quantityShrink([shrinkInventoryObject]);
    }
  };

  const updateGridState = (gridState) => {
    getPaginatedInventoryHistory(currentStore?.id, gridState);
    setGridState(gridState);
  };

  //------- handle item history button click
  const handleItemHistory = () => {
    toggleItemHistoryModal();
  };

  const handleTrackQuantityChange = (name, value, setFieldValue) => {
    setFieldValue("unitsOnHand", value ? state?.data?.price?.quantity : "");
  };

  //------ handle price value change
  const handlePriceChange = (values, value, setFieldValue) => {
    const isOnline = values?.isInstoreStockPrice;
    const cost = isOnline
      ? Number(values.onlineUnitPurchasePrice)
      : Number(values.costPerItem);
    const price = Number(value);

    const { profit, margin } = calculateProfitAndMargin(cost, price);

    setFieldValue(isOnline ? "onlineProfit" : "profit", profit);
    setFieldValue(isOnline ? "onlineMargin" : "margin", margin);
  };

  //------handle cost per value change
  const handleCostPerItemChange = (values, value, setFieldValue) => {
    const isOnline = values?.isInstoreStockPrice;
    const cost = Number(value);
    const price = Number(
      values?.[isOnline ? "onlineUnitSellPrice" : "unitsellprice"]
    );

    const { profit, margin } = calculateProfitAndMargin(cost, price);

    setFieldValue(isOnline ? "onlineProfit" : "profit", profit);
    setFieldValue(isOnline ? "onlineMargin" : "margin", margin);
  };

  //------handle toggle online price
  const handleToggleOnlinePrice = (isOnline, values, setFieldValue) => {
    setFieldValue("isInstoreStockPrice", isOnline);

    const cost =
      isOnline && values?.isOnlineQuantity
        ? Number(values.onlineUnitPurchasePrice)
        : Number(values.costPerItem);
    const price = Number(
      values?.[isOnline ? "onlineUnitSellPrice" : "unitsellprice"]
    );

    const { profit, margin } = calculateProfitAndMargin(cost, price);

    setFieldValue(isOnline ? "onlineProfit" : "profit", profit);
    setFieldValue(isOnline ? "onlineMargin" : "margin", margin);
  };

  const handleSubmit = (data) => {
    if (
      data?.serialNumber &&
      Number(data.unitsOnHand) + Number(data.onlineQuantity) > 1
    ) {
      customToast(toastMessages.SYSTEM_QUANTITY_MUST_BE_1, toastType.ERROR);
      return;
    } else if (
      isSystemProduct(getProductSubCategory(productDataObject?.genre)) &&
      !isSerialNumberUnique(
        data.serialNumber,
        inventoryProducts?.filter(
          (product) => product.id !== state?.data?.id
        ) || []
      )
    ) {
      customToast(
        toastMessages.PRODUCT_SERIAL_NUMBER_SHOULD_BE_UNIQUE,
        toastType.ERROR
      );
      return;
    }
    const updateInventoryObject = {
      ...getAddInventoryRootPayloadPartialObject({
        ...productDataObject,
        ...data,
        shopifySettingId:
          productShopifySettings?.marginObject?.id ||
          productDataObject.shopifySettingId,
        productType: getTypeOrCategoryObject(customTypes, data.productType)
          ?.productType,
      }),
      id: state?.data?.id,
      product_name: data?.productName,
      margin: data.margin,
      imgUrl: productDataObject?.imgUrl,
      tags: selectedTags,
      category_name: getTypeOrCategoryObject(
        customCategories,
        data.category_name
      )?.name,
      subcategory:
        !handleIsCustomItem({ tags: selectedTags }) &&
        productDataObject.productType === PRODUCT_TYPES_ENUMS.TRADING_CARD
          ? productDataObject.subcategory
          : (getTypeOrCategoryObject(customSubCategories, data.subcategory)
              ?.name ?? EMPTY_STRING),
      price: {
        ...getAddInventoryPricePayloadObject({
          ...productDataObject,
          ...data,
          isSeparateQuantity: data.isOnlineQuantity,
        }),
        type: isCustomItem
          ? data?.condition
          : (productCondition?.value ?? EMPTY_STRING),
        quantity: data?.trackQuantity ? data.unitsOnHand : 0,
        unit_purchase_price: data.costPerItem,
        unit_sell_price: data.unitsellprice,
        originalPrice: data.originalPrice,
        originalCondition: data?.originalCondition,
        marketPrice: handleBeautifyMarketPrice(productDataObject),
        profit: data.profit,
      },
      trackQuantity: data?.trackQuantity,
    };
    // consolidation test (if isConsolidationModal === true i.e user pressed yes so submit the form)
    const isConsolidation = inventoryProducts
      .filter(
        (inv) =>
          inv.id !== updateInventoryObject.id &&
          inv.store?.id === currentStore?.id
      )
      .find((inv) => {
        return isProductMetaDataSame(inv, updateInventoryObject);
      });
    if (
      isConsolidation &&
      !isConsolidationModal &&
      data.serialNumber !== EMPTY_STRING
    ) {
      customToast(
        toastMessages.PRODUCT_SERIAL_NUMBER_SHOULD_BE_UNIQUE,
        toastType.ERROR
      );
      return;
    } else if (isConsolidation && !isConsolidationModal) {
      setIsConsolidationModal(true);
      return;
    }
    if (data.unitsOnHand < state?.data?.price?.quantity) {
      setShrinkValue(state?.data?.price?.quantity - data.unitsOnHand);
      handleShow();
      setUpdatedInventory(updateInventoryObject);
    } else {
      updateInventory(
        currentStore?.id,
        updateInventoryObject,
        true,
        state?.gridState,
        navigate,
        state?.scrollRef
      );
    }
  };
  const handlePrintButtonClick = () => {
    togglePrintLabelModal();
  };
  //-------Change Logo image button
  const handleReplaceButtonClick = () => {
    hiddenFileInput.current.click();
  };

  //------- Hide/Show Item History Modal
  const toggleItemHistoryModal = () => {
    setIsItemHistoryModal(!isItemHistoryModal);
  };

  //------ handleEditShopifyPreset
  const handleEditShopifyPreset = () => {
    setInitialMapping(false);
    setProductShopifySettings({});
    toggleShopifyMappingModal();
    getShopifyMappingsById(
      currentStore?.id,
      productShopifySettings?.marginObject?.id || state?.data?.shopifySettingId
    );
  };

  //------- handleIsLinkToShopifyCheck
  const handleIsLinkToShopifyCheck = (name, value, values, setFieldValue) => {
    setFieldValue(name, value);
    if (!value) {
      setFieldValue("isOnlineQuantity", value);
      setFieldValue("isInstoreStockPrice", value);
      //setFieldValue("isOnlineUnitSellPrice", value);
      handleToggleOnlinePrice(value, values, setFieldValue);
      handleSeparateOnlineQuantityChange(
        "isOnlineQuantity",
        value,
        values,
        setFieldValue
      );
    }
  };

  //-------- handleSeparateOnlineQuantityChange
  const handleSeparateOnlineQuantityChange = (
    name,
    value,
    values,
    setFieldValue
  ) => {
    const onlineQuantity = values?.onlineQuantity || 0;
    const inStoreQuantity = values?.unitsOnHand || 0;
    const isOnlineQuantity = value;

    const totalQuantity = Number(onlineQuantity) + Number(inStoreQuantity);
    setFieldValue(name, isOnlineQuantity);
    if (!isOnlineQuantity) {
      setFieldValue("unitsOnHand", totalQuantity);
      const newCogs = handleAverageOutUnitPurcasePrice(
        inStoreQuantity,
        onlineQuantity,
        values?.costPerItem,
        values?.onlineCostPerItem
      );
      setFieldValue("costPerItem", newCogs);
      setFieldValue("onlineCostPerItem", newCogs);
    } else {
      setFieldValue("unitsOnHand", inStoreQuantity);
      setFieldValue("onlineQuantity", 0);
      setFieldValue("costPerItem", state?.data?.price?.unit_purchase_price);
      setFieldValue(
        "onlineCostPerItem",
        state?.data?.price?.onlineUnitPurchasePrice
      );
    }
  };
  const toggleTransferInventoryModal = () => {
    setIsTransferInventoryModal((prev) => !prev);
  };

  //------- get item history paginated
  useEffect(() => {
    if (currentStore && timeFrame.start && timeFrame.end) {
      updateGridState({
        ...gridState,
        pageSize: inventoryConstants.ITEM_HISTORY_LIST_LENGTH,
        searchQuery: getShortestSku(state?.data?.sku),
        filters: prepareFilterForInventoryHistoryPaginationCall(
          EMPTY_STRING,
          EMPTY_STRING,
          transactionType,
          timeFrame.start,
          timeFrame.end,
          EMPTY_STRING
        ),
      });
    }
  }, [timeFrame, transactionType, currentStore]);

  useEffect(() => {
    const productMetaData = {
      ...state?.data,
      id: state?.data?.product_id,
      category_name: state?.data.category_name,
      genre: isSystemProduct(state?.data.subcategory)
        ? state?.data.subcategory
        : state?.data.category_name,
      imgUrl: state?.data.imgUrl,
      productType: state?.data.productType,
      product_id: state?.data.product_id,
      product_name: state?.data.product_name,
      sourceApi: state?.data.apiSource,
    };
    if (state?.data.apiSource === inventoryConstants.PRICECHARTING_API) {
      getPricechartingProductById(productMetaData, state?.data?.product_id);
    } else if (state?.data.apiSource === inventoryConstants.TCG_PLAYER_API) {
      getTcgPlayerProductById(productMetaData, productMetaData.id);
    } else if (state?.data.apiSource === inventoryConstants.CUSTOM_ITEM) {
      getInventoryByCustomItemCheck(currentStore?.id);
    } else if (state?.data.apiSource === inventoryConstants.CSV_IMPORT_FILE) {
      setPokemonProductInReducer(productMetaData, state?.data);
    }
    return () => {
      emptyPriceChartingProductObject();
    };
  }, []);
  //-------update product condition and type
  useEffect(() => {
    const handleProductDefaultObject = async () => {
      if (priceChartingProductInfo.productObject) {
        await handleProductConditionUpdate(
          currentStore,
          priceChartingProductInfo,
          getInventoryByPricechartingId,
          setProductType,
          setProductUrl,
          productDataObject,
          setProductDataObject,
          productTags,
          setProductTagsList,
          () => {},
          () => {},
          setConditionList,
          setProductCondition,
          state?.data?.imgUrl
        );

        if (isFirstRenderRef.current) {
          isFirstRenderRef.current = false;
          const initialCondition = {
            label: state?.data?.price?.type,
            value: state?.data?.price?.type,
          };
          handleConditionChange(
            initialCondition,
            () => {},
            priceChartingProductInfo,
            productTags,
            setProductTagsList,
            setProductDataObject,
            productDataObject,
            () => {}
          );
          setProductCondition(initialCondition);
          setSelectedTags(state?.data?.tags);
        }
      }
    };
    handleProductDefaultObject();
  }, [priceChartingProductInfo.productObject]);

  useEffect(() => {
    if (productShopifySettings?.marginObject?.id) {
      setInitialMapping(getDefaultFields(productShopifySettings?.marginObject));
    }
  }, [productShopifySettings]);

  useEffect(() => {
    return () => {
      emptyShopifyProductSettings();
    };
  }, []);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={editInventoryValidationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
      >
        {({ values, setFieldValue }) => {
          return (
            <>
              <Topbar
                exportButton={true}
                title="Inventory Detail - Edit"
                handleClick={handlePrintButtonClick}
                label={buttonNameConstants.PRINT_PRODUCT_LABEL}
                buttonType={buttonTypeConstants.LIGHT_PURPLE}
                backNavigation={{
                  isVisible: true,
                  route: routesPathConstants.INVENTORY,
                  gridState: state?.gridState,
                  scrollRef: state?.scrollRef,
                }}
                isGhostButton={{
                  isVisible: true,
                  handleButtonClick: handleItemHistory,
                  buttonLabel: buttonNameConstants.ITEM_HISTORY,
                }}
                isEditShopifyPresetsButton={
                  isShopifyStoreConnected &&
                  formRef?.current?.values?.isLinkToShopify
                    ? {
                        isVisible: true,
                        handleButtonClick: handleEditShopifyPreset,
                        buttonLabel: buttonNameConstants.EDIT_SHOPIFY_PRESET,
                        isDisabled: isSpinnerEnabled(
                          spinnerArray,
                          shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID
                        )
                          ? true
                          : false,
                      }
                    : ""
                }
                isTransferButton={{
                  isVisible: isTransferInventoryEnabled(
                    currentStoreCompany,
                    stores
                  ),
                  handleButtonClick: toggleTransferInventoryModal,
                  buttonLabel: buttonNameConstants.TRANSFER,
                }}
              ></Topbar>
              <Row className="m-0 w-100  container-scrollbar user-information-wrapper edit-inventory-wrapper  pb-3">
                <Col className="p-0">
                  <Form className="main-row">
                    <Row className="m-0 mb-3  ">
                      <Col
                        md={5}
                        sm={12}
                        className="edit-invetory-right mt-4 mt-md-0"
                      >
                        <Row className="right-container m-0 p-0">
                          <Row className="m-0 completeBoxDiv">
                            <Col
                              md={9}
                              className="px-0 d-flex flex-column justify-content-center gap-3"
                            >
                              <p className="para-Text mb-0 text-break">
                                {state?.data?.product_name}
                              </p>
                              <div className="p-0 d-flex flex-wrap gap-2">
                                <span className="skitchin-Items">
                                  {state?.data?.category_name}
                                </span>
                                {state?.data?.subcategory && (
                                  <span className="skitchin-Items">
                                    {state?.data?.subcategory}
                                  </span>
                                )}
                              </div>
                              <span className="complete-number mt-0 d-flex align-items-center gap-2">
                                SKU : {skuToolTip(state)}
                              </span>
                            </Col>
                            <Col md={3}>
                              <div className="add-inventory-product-image edit-inventory-product-image">
                                <img
                                  src={
                                    productDataObject?.imgUrl || ProductImage
                                  }
                                />
                                <input
                                  type="file"
                                  className="d-none"
                                  accept=".png, .jpg, .jpeg"
                                  onChange={(e) =>
                                    handleUploadProductImage(
                                      e,
                                      activateSpinner,
                                      deactivateSpinner,
                                      productDataObject,
                                      setProductDataObject
                                    )
                                  }
                                  ref={hiddenFileInput}
                                />
                                <button
                                  onClick={handleReplaceButtonClick}
                                  type="button"
                                  className="replace-logo-button"
                                >
                                  <LogoImageReplaceIcon className="replace-icon" />
                                </button>
                              </div>
                            </Col>

                            {/* <p className="complete-box">
                          {state?.data?.price?.type}
                        </p> */}
                          </Row>
                          <Row className="m-0  market-price-div">
                            <Row className="d-flex m-0 p-0 justify-content-between align-items-center detail-div pb-4">
                              <Col className="price-market-text" md={6}>
                                Market Price:
                              </Col>
                              <Col
                                className={`price-market-amount d-flex justify-content-end align-items-center gap-3 ${
                                  isMarketPriceHigh(
                                    handleBeautifyMarketPrice(
                                      productDataObject
                                    ),
                                    values.unitsellprice,
                                    productTags,
                                    selectedTags
                                  ) && values.unitsellprice
                                    ? "text-danger"
                                    : ""
                                }`}
                                md={6}
                              >
                                {!isCustomItem &&
                                  productType ===
                                    PRODUCT_TYPES_ENUMS.VIDEO_GAME && (
                                    <img
                                      src={PricechartingImage}
                                      className="pricecharting-icon"
                                    />
                                  )}
                                $
                                {handleBeautifyMarketPrice(
                                  productDataObject,
                                  true
                                )}
                              </Col>
                            </Row>
                            <Row className="d-flex m-0 p-0 mt-2 justify-content-between pt-3">
                              <Col className="suggest-text " md={6}>
                                Suggested Sell Price:
                              </Col>
                              <Col
                                className="suggest-amount d-flex justify-content-end"
                                md={6}
                              >
                                $
                                {isNaN(
                                  convertToUsd(
                                    productDataObject?.suggestedSellPrice
                                  )
                                )
                                  ? "0.00"
                                  : parseToThousandSeperatorDecimalNumber(
                                      convertToUsd(
                                        productDataObject?.suggestedSellPrice ??
                                          0
                                      )
                                    )}
                              </Col>
                            </Row>
                            <Col className="p-0 mt-3 d-flex gap-2 ms-auto">
                              {state?.data?.apiSource ===
                              inventoryConstants.PRICECHARTING_API ? (
                                <>
                                  <Button
                                    handleClick={() => {
                                      handleViewEbaySales(
                                        state?.data?.product_name,
                                        state?.data?.category_name,
                                        state?.data?.subcategory
                                      );
                                    }}
                                    type="button"
                                    label={buttonNameConstants.EBAY_SALES}
                                    buttonType={
                                      buttonTypeConstants.GREEN_BUTTON
                                    }
                                    className="w-100"
                                  ></Button>
                                  <Button
                                    type="button"
                                    handleClick={() => {
                                      setProductUrl(
                                        `${
                                          process.env
                                            .REACT_APP_PRICECHARTING_IFRAME_URL
                                        }${stringToSlug(
                                          state?.data?.category_name
                                        )}/${stringToSlug(
                                          state?.data?.product_name
                                        )}`
                                      );
                                      handleShowIfram();
                                    }}
                                    label={buttonNameConstants.PRICE_CHARTING}
                                    buttonType={buttonTypeConstants.BLUE_BUTTON}
                                    className="w-100"
                                    IconImage={PricechartingIcon}
                                  ></Button>
                                </>
                              ) : (
                                <Button
                                  type="button"
                                  handleClick={() => {
                                    handleViewTCGPlayer(productDataObject);
                                  }}
                                  label={buttonNameConstants.VIEW_TCG_PLAYER}
                                  buttonType={buttonTypeConstants.BLUE_BUTTON}
                                  className="ms-auto w-50"
                                  isDisabled={!productDataObject?.tcgPlayerUrl}
                                ></Button>
                              )}
                            </Col>
                          </Row>
                          <Row className="m-0 product-stats product-stats-con-height container-scrollbar">
                            <Col className="product-stats-text">
                              Your Product Stats
                            </Col>

                            <div className="detail-div">
                              <p>Total Units Sold:</p>
                              <span>{state?.data?.price?.totalUnitsSold}</span>
                            </div>
                            <div className="detail-div">
                              <p>Average Cost of Goods:</p>
                              <span>
                                {" "}
                                $
                                {parseToThousandSeperatorDecimalNumber(
                                  state?.data?.price?.averageBuyPrice
                                )}
                              </span>
                            </div>
                            <div className="detail-div">
                              <p>Average Sold Price:</p>
                              <span>
                                $
                                {parseToThousandSeperatorDecimalNumber(
                                  state?.data?.price?.averageSellPrice
                                )}
                              </span>
                            </div>
                            <div className="detail-div">
                              <p>Max Trade:</p>
                              <span>
                                $
                                {state?.data?.price?.maxTrade
                                  ? parseToThousandSeperatorDecimalNumber(
                                      state?.data?.price?.maxTrade
                                    )
                                  : " -"}
                              </span>
                            </div>
                            <div className="detail-div">
                              <p>Max Cash:</p>
                              <span>
                                $
                                {state?.data?.price?.maxCash
                                  ? parseToThousandSeperatorDecimalNumber(
                                      state?.data?.price?.maxCash
                                    )
                                  : " -"}
                              </span>
                            </div>
                            <NetworkAveragePriceSelect
                              isModalChild={false}
                              networkAverageBuySellPrices={
                                productDataObject.networkAverageBuySellPrices
                              }
                              networkAveragePriceType={
                                NETWORK_AVERAGE_PRICE_TYPES.SELL_PRICE
                              }
                            />
                            <NetworkAveragePriceSelect
                              isModalChild={false}
                              networkAverageBuySellPrices={
                                productDataObject.networkAverageBuySellPrices
                              }
                              networkAveragePriceType={
                                NETWORK_AVERAGE_PRICE_TYPES.BUY_PRICE
                              }
                            />
                          </Row>
                        </Row>
                        <Row className="m-0 w-100 edit-invetory-left mt-3">
                          <div className="pricing-Div">
                            <Col md={12} className="pricing-Text p-0">
                              Tags(
                              {selectedTags?.filter(
                                (tag) =>
                                  tag !== inventoryConstants.CUSTOM_ITEM_TAG
                              ).length || 0}
                              ):
                            </Col>
                            <Col className="p-0">
                              <ProductTagList
                                isShowLabel={false}
                                className={
                                  "d-flex flex-column align-items-start mt-3"
                                }
                                productCondition={productCondition}
                                tagsList={productTagsList || []}
                                suggestedArrayList={productTags}
                                onSelectTagsChange={(selectedTags) => {
                                  onSelectTagsChange(
                                    selectedTags,
                                    setSelectedTags,
                                    productDataObject,
                                    setProductDataObject,
                                    priceChartingProductInfo,
                                    productCondition,
                                    productType
                                  );
                                }}
                                productDetail={{
                                  ...state?.data,
                                  tags: state?.data.tags.map((tag, index) => ({
                                    id: index,
                                    label: tag,
                                    selected: true,
                                  })),
                                }}
                              />
                            </Col>
                          </div>
                        </Row>
                      </Col>
                      <Col className="" md={7} sm={12}>
                        <div className="edit-invetory-left ">
                          <Row className="p-0 m-0 left-container p-0">
                            <Row className=" m-0 p-0">
                              <Row className="m-0 py-3 edit-items-detail-wrapper px-1">
                                <Col
                                  md={6}
                                  className="pricing-Text d-flex align-items-center"
                                >
                                  Item Details
                                </Col>
                                {isShopifyStoreConnected && (
                                  <Col
                                    md={6}
                                    className="d-flex justify-content-end align-items-center"
                                  >
                                    <CheckboxField
                                      key={`${values?.onlineQuantity}-${values?.unitsOnHand}`}
                                      name="isLinkToShopify"
                                      label="Link to Shopify"
                                      isLabelLeft={true}
                                      handleChange={(name, value) => {
                                        handleIsLinkToShopifyCheck(
                                          name,
                                          value,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                  </Col>
                                )}
                                <Row className="mx-auto px-0">
                                  <Col className="mt-3">
                                    <InputTextField
                                      label="Title"
                                      maxLength={100}
                                      className="border"
                                      name="productName"
                                      placeHolder="Enter Title"
                                      disabled={!isCustomItem}
                                    />
                                  </Col>
                                  {isTcgPlayerApi(state?.data) && (
                                    <Col md={4} className="mt-3">
                                      <SelectGrade
                                        label="Grading"
                                        value={values.grade}
                                        setFieldValue={setFieldValue}
                                        conditionComponent={{
                                          setConditionList: setConditionList,
                                          setProductCondition:
                                            setProductCondition,
                                        }}
                                        priceChartingProductInfo={
                                          priceChartingProductInfo
                                        }
                                        setPriceChartingProductInfo={
                                          setPriceChartingProductInfo
                                        }
                                      />
                                    </Col>
                                  )}
                                  <Col md={4} className=" mt-3">
                                    {isCustomItem ? (
                                      <CustomItemConditionSelectField
                                        customTypes={customTypes}
                                        values={values}
                                      />
                                    ) : (
                                      <CategoriesDropdown
                                        options={conditionList}
                                        disabled={false}
                                        handleChange={(selectedOption) => {
                                          state.data.tags = [];
                                          return handleConditionChange(
                                            selectedOption,
                                            setProductCondition,
                                            priceChartingProductInfo,
                                            productTags,
                                            setProductTagsList,
                                            setProductDataObject,
                                            productDataObject,
                                            setSelectedTags,
                                            setPriceChartingProductInfo
                                          );
                                        }}
                                        noOptionsMessage="Empty Box"
                                        label={"Condition"}
                                        placeholder={handleShowNintendoCondition(
                                          state?.data?.category_name,
                                          state?.data?.price?.type
                                        )}
                                        SelectIconImage={
                                          categoryDropdownConstants.BOX_ICON
                                        }
                                        isClearable={false}
                                        value={productCondition}
                                      />
                                    )}
                                  </Col>
                                </Row>
                                <Col md={4} className="mt-3">
                                  <CustomItemProductTypeSelectField
                                    setFieldValue={setFieldValue}
                                    customTypes={customTypes}
                                    isDisabled={!isCustomItem}
                                  />
                                </Col>
                                <Col md={4} className="mt-3">
                                  <CustomItemCategorySelectField
                                    setFieldValue={setFieldValue}
                                    customCategories={customCategories}
                                    values={values}
                                    isDisabled={!isCustomItem}
                                  />
                                </Col>
                                <Col md={4} className="mt-3">
                                  <CustomItemSubcategorySelectField
                                    setFieldValue={setFieldValue}
                                    values={values}
                                    customTypes={customTypes}
                                    customCategories={customCategories}
                                    customSubCategories={customSubCategories}
                                    isDisabled={!isCustomItem}
                                  />
                                </Col>
                                {isTcgPlayerApi(state?.data) && (
                                  <Col md={6} className="mt-3">
                                    <SelectLanguage
                                      label="Language"
                                      value={values.language}
                                      setFieldValue={setFieldValue}
                                      priceChartingProductInfo={
                                        priceChartingProductInfo
                                      }
                                      setPriceChartingProductInfo={
                                        setPriceChartingProductInfo
                                      }
                                      setPriceChartingProductInfoComponent={
                                        setProductDataObject
                                      }
                                    />
                                  </Col>
                                )}
                                {isTcgPlayerApi(state?.data) &&
                                  state?.data?.cardRarity && (
                                    <Col md={6} className="mt-3">
                                      <SelectCardRarity
                                        label="Printing"
                                        value={values.cardRarity}
                                        setFieldValue={setFieldValue}
                                        priceChartingProductInfo={
                                          priceChartingProductInfo
                                        }
                                        setPriceChartingProductInfo={
                                          setPriceChartingProductInfo
                                        }
                                        setPriceChartingProductInfoComponent={
                                          setProductDataObject
                                        }
                                      />
                                    </Col>
                                  )}
                                {isTcgPlayerApi(state?.data) && (
                                  <Col md={6} className="mt-3">
                                    <Set
                                      label="Set"
                                      value={values.set}
                                      setFieldValue={setFieldValue}
                                      priceChartingProductInfo={
                                        priceChartingProductInfo
                                      }
                                    />
                                  </Col>
                                )}
                                {isTcgPlayerApi(state?.data) && (
                                  <Col md={6} className="mt-3">
                                    <Rarity
                                      label="Rarity"
                                      value={values.rarity}
                                      setFieldValue={setFieldValue}
                                      priceChartingProductInfo={
                                        priceChartingProductInfo
                                      }
                                    />
                                  </Col>
                                )}
                                {isTcgPlayerApi(state?.data) && (
                                  <>
                                    <Col md={6} className="mt-3">
                                      <Barcode
                                        label="Barcode"
                                        value={values.barcode}
                                        setFieldValue={setFieldValue}
                                        priceChartingProductInfo={
                                          priceChartingProductInfo
                                        }
                                      />
                                    </Col>
                                  </>
                                )}
                                {isSystemProduct(
                                  getProductSubCategory(
                                    productDataObject?.genre
                                  )
                                ) && (
                                  <Col md={6} className="mt-3">
                                    <InputTextField
                                      label="Serial Number"
                                      name="serialNumber"
                                      maxLength={100}
                                      placeHolder="Enter Serial Number"
                                      className="border add-inventory-serial-number-field"
                                      handleChange={() => {
                                        if (
                                          values?.serialNumber &&
                                          (values.unitsOnHand > 1 ||
                                            values.onlineQuantity > 1)
                                        ) {
                                          setFieldValue("onlineQuantity", 1);
                                          setFieldValue("unitsOnHand", 1);
                                        }
                                      }}
                                    />
                                  </Col>
                                )}
                                {isCustomItem && (
                                  <Col md={6} className="mt-3">
                                    <InputTextField
                                      name="upc"
                                      placeHolder=""
                                      className="border"
                                      label="UPC(Optional)"
                                    />
                                  </Col>
                                )}
                              </Row>

                              <Row className="mt-4 pricing-Div m-0 pb-3 px-1">
                                <Col
                                  md={6}
                                  className="pricing-Text d-flex align-items-center"
                                >
                                  Quantity
                                </Col>
                                <Col
                                  md={6}
                                  className="d-flex flex-column justify-content-end align-items-end"
                                >
                                  {isCustomItem && (
                                    <CheckboxField
                                      name="trackQuantity"
                                      label="Track Quantity"
                                      isLabelLeft={true}
                                      handleChange={(name, value) => {
                                        handleTrackQuantityChange(
                                          name,
                                          value,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                  )}
                                  {handleIsLinkToShopify(
                                    currentStore,
                                    values
                                  ) && (
                                    <CheckboxField
                                      key={`${values?.onlineQuantity}-${values?.unitsOnHand}`}
                                      name="isOnlineQuantity"
                                      label="Separate In-Store & Online Quantities"
                                      isLabelLeft={true}
                                      handleChange={(name, value) => {
                                        handleSeparateOnlineQuantityChange(
                                          name,
                                          value,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                  )}
                                </Col>
                                <Col md={6} className="mt-2">
                                  <InputNumberField
                                    name="unitsOnHand"
                                    placeHolder={`Quantity (${
                                      values.isOnlineQuantity
                                        ? "In-Store"
                                        : "All Available"
                                    }):`}
                                    type="number"
                                    isConvertToDecimal={false}
                                    isHandleKeyDown={true}
                                    min={-9999}
                                    step={"1"}
                                    pattern="-?[0-9]+"
                                    label={`Quantity (${
                                      values.isOnlineQuantity
                                        ? "In-Store"
                                        : "All Available"
                                    }):`}
                                    disabled={
                                      !values?.trackQuantity ||
                                      values?.serialNumber
                                    }
                                  />
                                </Col>
                                <Col md={6} className="mt-2">
                                  {values.isOnlineQuantity &&
                                    handleIsLinkToShopify(
                                      currentStore,
                                      values
                                    ) && (
                                      <InputNumberField
                                        name="onlineQuantity"
                                        placeHolder={"Quantity (Online):"}
                                        type="number"
                                        isConvertToDecimal={false}
                                        isHandleKeyDown={true}
                                        min={-9999}
                                        step={"1"}
                                        pattern="-?[0-9]+"
                                        label="Quantity (Online):"
                                        disabled={
                                          !values?.trackQuantity ||
                                          values?.serialNumber
                                        }
                                      />
                                    )}
                                </Col>
                              </Row>
                              <Row className="mt-4 pricing-Div pb-3 m-0 px-0 ">
                                <Col
                                  md={12}
                                  className="d-flex justify-content-between align-items-center"
                                >
                                  <div className="d-flex align-items-center gap-2 ">
                                    <span className="pricing-Text">
                                      Pricing
                                    </span>
                                    {handleIsLinkToShopify(
                                      currentStore,
                                      values
                                    ) && (
                                      <ToggleButtonWithText
                                        isToggle={values.isInstoreStockPrice}
                                        handleLeftButtonClick={() => {
                                          handleToggleOnlinePrice(
                                            false,
                                            values,
                                            setFieldValue
                                          );
                                        }}
                                        handleRightButtonClick={() => {
                                          handleToggleOnlinePrice(
                                            true,
                                            values,
                                            setFieldValue
                                          );
                                        }}
                                        leftButtonLabel="In-Store"
                                        rightButtonLabel="Online"
                                        className="discount-toggle-button add-inventory-quantity-toggle-switch"
                                      />
                                    )}
                                  </div>
                                  {/* {values.isLinkToShopify && (
                                    <CheckboxField
                                      name="isOnlineUnitSellPrice"
                                      label="Different Online Price"
                                      isLabelLeft={true}
                                      handleChange={(name, value) => {
                                        handleToggleOnlinePrice(
                                          value,
                                          values,
                                          setFieldValue
                                        );
                                      }}
                                    />
                                  )} */}
                                </Col>

                                <Col md={4} className="mt-3 ">
                                  <InputNumberField
                                    name={
                                      values.isInstoreStockPrice
                                        ? "onlineUnitSellPrice"
                                        : "unitsellprice"
                                    }
                                    handleChange={(value) =>
                                      handlePriceChange(
                                        values,
                                        value,
                                        setFieldValue
                                      )
                                    }
                                    placeHolder="$74.99"
                                    type="number"
                                    label={
                                      values.isInstoreStockPrice
                                        ? "Online Price"
                                        : "Stock Price"
                                    }
                                    disabled={false}
                                    IconImage={DollarIcon}
                                    className={`${
                                      isMarketPriceHigh(
                                        handleBeautifyMarketPrice(
                                          productDataObject
                                        ),
                                        values.unitsellprice,
                                        productTags,
                                        selectedTags
                                      ) && values.unitsellprice
                                        ? "border-danger"
                                        : ""
                                    }`}
                                  />
                                </Col>
                                <Row className="mt-3 p-0 m-0">
                                  <Col md={4} className="">
                                    <InputNumberField
                                      name={
                                        values.isInstoreStockPrice &&
                                        values?.isOnlineQuantity
                                          ? "onlineCostPerItem"
                                          : "costPerItem"
                                      }
                                      label="Cost per Item: "
                                      placeHolder="$74.99"
                                      type="number"
                                      IconImage={DollarIcon}
                                      handleChange={(value) =>
                                        handleCostPerItemChange(
                                          values,
                                          value,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  </Col>
                                  <Col md={4} className="">
                                    <InputTextField
                                      name={
                                        values.isInstoreStockPrice
                                          ? "onlineProfit"
                                          : "profit"
                                      }
                                      placeHolder="0.00"
                                      label={"Profit:"}
                                      IconImage={DollarIcon}
                                      disabled={true}
                                    />
                                  </Col>
                                  <Col md={4} className="">
                                    <InputTextField
                                      name={
                                        values.isInstoreStockPrice
                                          ? "onlineMargin"
                                          : "margin"
                                      }
                                      placeHolder="0.00"
                                      label={"Profit Margin"}
                                      LeftIconImage={PercentageIcon}
                                      disabled={true}
                                    />
                                  </Col>
                                </Row>
                              </Row>
                            </Row>
                          </Row>
                        </div>
                        <Row className="w-100 m-0">
                          <Col
                            md={8}
                            className="mt-3 pb-4 pe-0 d-flex gap-2 ms-auto"
                          >
                            <Button
                              type="button"
                              label={buttonNameConstants.CANCEL}
                              buttonType={buttonTypeConstants.GHOST_BUTTON}
                              className="w-100"
                              handleClick={() => {
                                handleCancelButton();
                              }}
                            ></Button>
                            <Button
                              type="submit"
                              className="w-100"
                              label={buttonNameConstants.SAVE}
                            ></Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Form>{" "}
                </Col>
              </Row>
            </>
          );
        }}
      </Formik>
      {isConsolidationModal && (
        <ConfirmationModal
          isConfirmationModal={isConsolidationModal}
          handleNoButtonClick={() => {
            setIsConsolidationModal(false);
          }}
          handleYesButtonClick={() => {
            if (formRef.current) {
              formRef.current.handleSubmit();
            }
          }}
          message="An item with these details already exists. Saving/Adding will transfer the quantity of this version into an existing version. Proceed?"
        />
      )}
      <Modal
        size="md"
        animation={true}
        centered
        backdrop="static"
        show={show}
        className={"nested-modal-z-index"}
        backdropClassName={"nested-modal-z-index"}
      >
        <Modal.Body>
          {" "}
          <Row className="m-0 p-0">
            <Col
              md={3}
              className="img-Div-stolen d-flex p-0 box-shadow-default"
            >
              <img
                src={state?.data?.imgUrl ? state.data.imgUrl : ProductImage}
                alt=""
              />
            </Col>
            <Col md={9} className="m-0 pe-0">
              <Row className="m-0 p-0 h-100">
                <Col md={12} className="p-0 mt-2 stolen-card-text ">
                  Was {state?.data?.product_name} lost or stolen?
                </Col>
                <Col md={12} className="mt-auto p-0 d-flex gap-2 ">
                  <Button
                    type="button"
                    label={buttonNameConstants.NO}
                    buttonType={buttonTypeConstants.GHOST_BUTTON}
                    className="w-100"
                    handleClick={() => {
                      // handleCancelButton();
                      handleShrinkModalSubmit(false);
                    }}
                  ></Button>
                  <Button
                    type="button"
                    className="w-100"
                    handleClick={() => {
                      // setShrinkValue(buttonNameConstants.YES);
                      handleShrinkModalSubmit(true);
                    }}
                    label={buttonNameConstants.YES}
                  ></Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal
        size="xl"
        animation={true}
        centered
        backdrop="static"
        show={showIframe}
        onHide={handleCloseIfram}
        // className="iframe-edit-inventory"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <iframe
            title="Product Iframe"
            src={productUrl}
            className="iframe-website-edit-inventory  w-100"
          />
        </Modal.Body>
      </Modal>
      <PrintLabelModal
        printLabelModal={printLabelModal}
        togglePrintLabelModal={togglePrintLabelModal}
        // selectedRows={selectedRows}
        singlePrintArray={[state?.data]}
      />
      {isItemHistoryModal ? (
        <ItemHistoryModal
          item={state?.data}
          timeFrame={timeFrame}
          gridState={gridState}
          setGridState={setGridState}
          setTimeFrame={setTimeFrame}
          inventoryHistory={inventoryHistory}
          updateGridState={updateGridState}
          setTransactionType={setTransactionType}
          isItemHistoryModal={isItemHistoryModal}
          toggleItemHistoryModal={toggleItemHistoryModal}
        />
      ) : (
        ""
      )}{" "}
      {isTransferInventoryModal && (
        <TransferInventoryModal
          stateData={{
            navigate: navigate,
            data: state?.data,
          }}
          selectedRows={[]}
          isEditInventory={true}
          singlePrintArray={[state?.data]}
          isTransferInventoryModal={isTransferInventoryModal}
          toggleTransferInventoryModal={toggleTransferInventoryModal}
        />
      )}
      {initialMapping && (
        <ShopifyPresetsMappingModal
          isShowSkeleton={isSpinnerEnabled(
            spinnerArray,
            shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID
          )}
          initialMappings={initialMapping}
          handleSaveClick={handleSaveMappning}
          isShopifyMappingModal={isShopifyPresetModal}
          toggleShopifyMappingModal={toggleShopifyMappingModal}
        />
      )}
    </>
  );
};

//-------EditInventory component ends here
const skuToolTip = (state) => {
  return (
    state?.data?.sku?.length && (
      <>
        <p id="sku-drop" className="w-25 cursor-pointer text-nowrap mb-0">
          {state.data.sku[0]}
        </p>
        <CustomTooltip
          anchorSelect={`#${"sku-drop"}`}
          place="bottom-start"
          className={"tooltip-for-text sku-tooltip"}
        >
          {state.data.sku.map((sku) => (
            <p className="p-0 m-0">{sku}</p>
          ))}
        </CustomTooltip>
      </>
    )
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  shopify: state.shopify,
  inventory: state.inventory,
  stores: state.store.stores,
  tradeDiscount: state.tradeDiscount,
  company: state.authentication.company,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  productTags: state.inventory.productTags,
  customTypes: state.itemOrganization.customTypes,
  inventoryProducts: state.inventory.inventoryProducts,
  currentStoreCompany: state.company.currentStoreCompany,
  customCategories: state.itemOrganization.customCategories,
  customSubCategories: state.itemOrganization.customSubCategories,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  quantityShrink: (data) => dispatch(inventoryActions.quantityShrink(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  emptyPriceChartingProductObject: () =>
    dispatch(inventoryActions.emptyPriceChartingProductObject()),
  getInventoryByPricechartingId: (storeId, data) =>
    dispatch(inventoryActions.getInventoryByPricechartingId(storeId, data)),
  getInventoryByCustomItemCheck: (storeId) =>
    dispatch(inventoryActions.getInventoryByCustomItemCheck(storeId)),
  getPaginatedInventoryHistory: (storeId, gridState) =>
    dispatch(inventoryActions.getPaginatedInventoryHistory(storeId, gridState)),
  setPriceChartingProductInfo: (data) =>
    dispatch(inventoryActions.setPriceChartingProductInfo(data)),
  getShopifyMappingsById: (storeId, id) =>
    dispatch(shopifyActions.getShopifyMappingsById(storeId, id)),
  getPricechartingProductById: (productMetaData, productId) =>
    dispatch(
      inventoryActions.getPricechartingProductById(productMetaData, productId)
    ),
  setPokemonProductInReducer: (productMetaData, value) =>
    dispatch(
      inventoryActions.setPokemonProductInReducer(productMetaData, value)
    ),
  getTcgPlayerProductById: (productMetaData, productId) =>
    dispatch(
      inventoryActions.getTcgPlayerProductById(productMetaData, productId)
    ),
  updateInventory: (
    storeId,
    data,
    isLabelNotification,
    gridState,
    isPageRedirect,
    scrollRef,
    isAddShrinkTracking
  ) =>
    dispatch(
      inventoryActions.updateInventory(
        storeId,
        data,
        isLabelNotification,
        gridState,
        isPageRedirect,
        scrollRef,
        isAddShrinkTracking
      )
    ),
  setProductShopifySettings: (data) =>
    dispatch(inventoryActions.setProductShopifySettings(data)),
  createProductMappingObject: (storeId, data, toggleShopifyMappingModal) =>
    dispatch(
      shopifyActions.createProductMappingObject(
        storeId,
        data,
        toggleShopifyMappingModal
      )
    ),
  emptyShopifyProductSettings: () =>
    dispatch(shopifyActions.emptyShopifyProductSettings()),
});

//-------Export EditInventory Component
export default connect(mapStateToProps, mapDispatchToProps)(EditInventory);
